

export var proweb =(function() {
    var self = {};
    var com = {};
    com.qas = {};
    window['interface'] = {};
    var business = {};
    window.events = {};

    com.qas.READY_STATE_COMPLETE = 4;
    com.qas.PROMPTSET = 'Default';
    com.qas.MAXIMUM_CONNECTION_ATTEMPTS = 3;

    var promptMsg = 'Validating Address Information...';

    self.accountConfigManager = {};

    var QasElementService = {
        getAjaxUrl: function() {
            return self.accountConfigManager.system['qas_service_url'];
        },
        getAddressLayout: function() {
            return document.getElementById('ADDRESSLAYOUT') !== null ? document.getElementById('ADDRESSLAYOUT').value : 'Database layout';
        },
        getFormButtonId: function() {
            return document.getElementById('FORM_BUTTON_ID') !== null ? document.getElementById('FORM_BUTTON_ID').value : '';
        },
        getRunAsPopup: function() {
            return document.getElementById('RUN_AS_POPUP') !== null ? document.getElementById('RUN_AS_POPUP').value : '';
        },
        getIgnoreUnmatchedAddresses: function() {
            return document.getElementById('IGNORE_UNMATCHED_ADDRESSES') !== null ? document.getElementById('IGNORE_UNMATCHED_ADDRESSES').value : '';
        },
        getIgnoreConnectionError: function() {
            return document.getElementById('IGNORE_CONNECTION_ERROR') !== null ? document.getElementById('IGNORE_CONNECTION_ERROR').value : '';
        },
        getDpvInteractive: function() {
            return document.getElementById('DPV_INTERACTIVE') !== null ? document.getElementById('DPV_INTERACTIVE').value : '';
        },
        getCountrySet: function() {
            var countryElem = 'USA';
            try {
                var country = locale.getCountry().toUpperCase();
                var countryMap = {
                    US: 'USA',
                    CA: 'CAN',
                    GB: 'GBR',
                    SG: 'SGP',
                    AU: 'AUS',
                    NZ: 'NZL'
                };

                if (countryMap[country]) {
                    countryElem = countryMap[country];
                }
            } catch (e) {}
            return countryElem;
        }
    };

    // All messages used by the application are stored as constants here for ease of manipulation
    // added a function to set the messages for flexibility with CAN/USA AJAX..
    events.setMessages = function() {
        var countrySet = QasElementService.getCountrySet();

        if (countrySet == 'CAN') {
            com.qas.MSG_PREMPARTIAL = '\<b\>Sorry, we think your apartment/suite/unit is missing or wrong<\/b\>\<br\> To proceed, please check and chose from one'
            + ' of the options below.';
            com.qas.MSG_STREETPARTIAL = '\<b\>Sorry, we don\'t recognize your house or building number.<\/b\>\<br\> To proceed, please check and choose from one of the '
            + 'options below.';
            com.qas.MSG_MULITPLE = '\<b\>We found more than one match for your address.<\/b\> \<br\> To proceed, please choose one of the options below.';
            com.qas.MSG_INTERACTION = '\<b\>We think that your address may be incorrect or incomplete.<\/b\> \<br\>To proceed, please choose one of the options below.';
            com.qas.MSG_HEADER = 'Verify your address details';
            com.qas.MSG_PREMPARTIAL_ERROR = 'The secondary number you entered could not be found. Please refer '
            + 'to list of options below.';
            com.qas.MSG_STREETPARTIAL_ERROR = 'The street number you entered could not be found. Please refer '
            + 'to list of options below.';
            com.qas.MSG_APPENDAPT = '\<b\>Sorry, we think your apartment/suite/unit may be missing<\/b\>\<br\> To proceed, please check and chose from one'
            + ' of the options below.';
            com.qas.MSG_NONE = '\<b\>Sorry, we could not find a match for your address.<\/b\>'
            + '\<br\>To proceed, please choose one of the options below.';
            com.qas.MSG_200 = 'Your address selection covers a range of addresses. Enter your exact details.';
            com.qas.MSG_REFINE = 'Your address selection covers a range of addresses. Enter your exact details.';
            com.qas.MSG_REFINE_ERROR = 'Invalid range. Please input another refinement number.';

            com.qas.WAIT_MESSAGE = 'Validating address data ...';
        } else if (countrySet == 'USA') {
            com.qas.MSG_PREMPARTIAL = '\<b\>Sorry, we think your apartment/suite/unit is missing or wrong<\/b\>\<br\> To proceed, please check and chose from one'
            + ' of the options below.';
            com.qas.MSG_STREETPARTIAL = '\<b\>Sorry, we don\'t recognize your house or building number.<\/b\>\<br\> To proceed, please check and choose from one of the '
            + 'options below.';
            com.qas.MSG_MULITPLE = '\<b\>We found more than one match for your address.<\/b\> \<br\> To proceed, please choose one of the options below.';
            com.qas.MSG_INTERACTION = '\<b\>We think that your address may be incorrect or incomplete.<\/b\> \<br\>To proceed, please choose one of the options below.';
            com.qas.MSG_INTERACTION_DPV_FAILED = '\<b\>We could not validate your apartment, suite or unit number.<\/b\> \<br\>To proceed, please choose one of the options below.';
            com.qas.MSG_HEADER = 'Verify your address details';
            com.qas.MSG_PREMPARTIAL_ERROR = 'The secondary number you entered could not be found. Please refer '
            + 'to list of options below.';
            com.qas.MSG_STREETPARTIAL_ERROR = 'The street number you entered could not be found. Please refer '
            + 'to list of options below.';
            com.qas.MSG_REFINE = 'Your address selection covers a range of addresses. Enter your exact details.';
            com.qas.MSG_REFINE_FOUR = 'Your address selection covers a range of ZIP+4\'s. Enter the exact +4 code required.';
            com.qas.MSG_REFINE_ERROR = 'Invalid range. Please input another refinement number.';
            com.qas.MSG_NONE = '\<b\>Sorry, we could not find a match for your address.<\/b\>'
            + '\<br\>To proceed, please choose one of the options below.';
            com.qas.WAIT_MESSAGE = promptMsg;
        } else if (countrySet == 'GBR' || countrySet == 'SGP') {
            com.qas.MSG_PREMPARTIAL = '\<b\>Sorry, we think your Flat is missing or wrong<\/b\>\<br\> To proceed, please check and chose from one'
            + ' of the options below.';
            com.qas.MSG_STREETPARTIAL = '\<b\>Sorry, we don\'t recognise your house or building number.<\/b\>\<br\> To proceed, please check and choose from one of the '
            + 'options below.';
            com.qas.MSG_MULITPLE = '\<b\>We found more than one match for your address.<\/b\> \<br\> To proceed, please choose one of the options below.';
            com.qas.MSG_INTERACTION = '\<b\>We think that your address may be incorrect or incomplete.<\/b\> \<br\>To proceed, please choose one of the options below.';
            com.qas.MSG_INTERACTION_DPV_FAILED = '\<b\>We could not validate your flat number.<\/b\> \<br\>To proceed, please choose one of the options below.';
            com.qas.MSG_HEADER = 'Verify your address details';
            com.qas.MSG_PREMPARTIAL_ERROR = 'The secondary number you entered could not be found. Please refer '
            + 'to list of options below.';
            com.qas.MSG_STREETPARTIAL_ERROR = 'The street number you entered could not be found. Please refer '
            + 'to list of options below.';
            com.qas.MSG_REFINE = 'Your address selection covers a range of addresses. Enter your exact details.';
            com.qas.MSG_REFINE_FOUR = 'Your address selection covers a range of ZIP+4\'s. Enter the exact +4 code required.';
            com.qas.MSG_REFINE_ERROR = 'Invalid range. Please input another refinement number.';
            com.qas.MSG_NONE = '\<b\>Sorry, we could not find a match for your address.<\/b\>'
            + '\<br\>To proceed, please choose one of the options below.';
            com.qas.WAIT_MESSAGE = promptMsg;
        } else {
            com.qas.MSG_PREMPARTIAL = '\<b\>Sorry, we think your apartment/suite/unit is missing or wrong<\/b\>\<br\> To proceed, please check and chose from one'
            + ' of the options below.';
            com.qas.MSG_STREETPARTIAL = '\<b\>Sorry, we don\'t recognize your house or building number.<\/b\>\<br\> To proceed, please check and choose from one of the '
            + 'options below.';
            com.qas.MSG_MULITPLE = '\<b\>We found more than one match for your address.<\/b\> \<br\> To proceed, please choose one of the options below.';
            com.qas.MSG_INTERACTION = '\<b\>We think that your address may be incorrect or incomplete.<\/b\> \<br\>To proceed, please choose one of the options below.';
            com.qas.MSG_HEADER = 'Verify your address details';
            com.qas.MSG_PREMPARTIAL_ERROR = 'The secondary number you entered could not be found. Please refer '
            + 'to list of options below.';
            com.qas.MSG_STREETPARTIAL_ERROR = 'The street number you entered could not be found. Please refer '
            + 'to list of options below.';
            com.qas.MSG_REFINE = 'Your address selection covers a range of addresses. Enter your exact details.';
            com.qas.MSG_REFINE_FOUR = 'Your address selection covers a range of ZIP+4\'s. Enter the exact +4 code required.';
            com.qas.MSG_REFINE_ERROR = 'Invalid range. Please input another refinement number.';
            com.qas.MSG_NONE = 'A match for your address could not be found. '
            + 'Please choose one of the options below to proceed.';
            com.qas.WAIT_MESSAGE = promptMsg;
        }
    };

    // Variable to hold the address that was originally entered
    var originaladdress;
    var finaladdress;

    // Variable to hold the orginal third party button click events
    window.existing_button_onclick = '';

    // Set the state of the seach (initally false)
    window.is_verified = false;

    // Hold the verify level as a global var so that it can be referred to as the last action
    window.current_widget = '';

    // Variable to hold the last verify level
    window.verify_level = '';

    // Variable to hold the current search moniker (for refine prompting)
    var current_moniker ='';

    // Variable to count tries to the server
    window.number_of_connection_attempts = 0;

    // variable to tell if interaction has been accepted
    var interaction_verified = '';

    /** ************************************************************************************************
 * Constructor for the com.qas.ContentLoader object. This handles all interaction with the server
 * and ensures that the return codes are correctly handled.
 * @param url The url for the server call
 * @param onload The name of the method in the event of success
 * @param onerror The name of the method to call in the event of failure
 * @param method Http submit method (get/ post)
 * @param params An array of parameters to send
 * @param contentType The http requeest content type
 **************************************************************************************************/
    com.qas.ContentLoader = function(onLoad, onError, method, params, contentType) {
        this.req = null;
        this.onLoad = onLoad;
        this.onError = (onError) ? onError : this.defaultError;
        this.url = QasElementService.getAjaxUrl();
        this.loadXMLDoc(method, params, contentType);
    };

    com.qas.ContentLoader.prototype =
{
    /**
     * Private method to make the http request and call the specified onLoad/ onError as
     * appropriate (also sets the content type).
     */
    loadXMLDoc: function(method, params, contentType) {
        // Parameters to store the last method call to handle re-submits
        this.last_method = method;
        this.last_params = params;
        this.last_content = contentType;

        if (! method) {
            method = 'GET';
        }
        if (! contentType && method == 'POST') {
            contentType = 'application/x-www-form-urlencoded';
        }
        if (window.XMLHttpRequest) {
            this.req = new XMLHttpRequest();
        } else if (window.ActiveXObject) {
            this.req = new ActiveXObject('Microsoft.XMLHTTP');
        }
        if (this.req) {
            try {
                // set
                try {
                    this.req.timeout = 10000;
                } catch (Exception) {}
                var loader = this;
                this.req.onreadystatechange = function() {
                    loader.onReadyState.call(loader);
                };
                this.req.open(method, this.url, true);

                if (contentType) {
                    this.req.setRequestHeader('Content-Type', contentType);
                }
                this.req.send(encodeURI(params));
            } catch (err) {
                this.onError.call(this);
            }
        }
    },

    /**
     * Method deals with the return from the server and makes the appropriate call as specified
     */
    onReadyState: function() {
        var req = this.req;
        var ready = req.readyState;


        if (ready == com.qas.READY_STATE_COMPLETE) {
            var httpStatus = req.status;
            if (httpStatus == 200 || httpStatus == 0) {
                this.onLoad.call(this);
            } else {
                if (number_of_connection_attempts < com.qas.MAXIMUM_CONNECTION_ATTEMPTS) {
                    number_of_connection_attempts++;
                    this.loadXMLDoc(this.last_method, this.last_params, this.last_content);
                } else {
                    this.onError.call(this);
                }
            }
        }
    },

    /**
     * The default error message, where no other error method is specified
     */
    defaultError: function() {
        var errorMsg = 'An error has occurred. Please check the settings in the '
            + 'file proweb.htm and ensure that the server is running correctly';

        window['interface'].inlineError(errorMsg);
    }
};

    /** ************************************************************************************************
 * Simple class for managing parameters. Users pass parameters to the class via the addParameter
 * method, and then access the correctly formatted string from toString(). No arg constructor.
 **************************************************************************************************/
    com.qas.AjaxParameters = function() {
        this.parameter_string = '';
    };

    com.qas.AjaxParameters.prototype =
{
    /**
     * Adds a name/ value pair (both sent as strings)
     */
    addParameter: function(name, value) {
        this.parameter_string = this.parameter_string +
            name + '=' + value + '&';
    },

    /**
     * Returns all of the parameters as a formatted string ready for HTTP
     */
    toString: function() {
        return this.parameter_string.slice(0, this.parameter_string.length - 1);
    }
};

    /** ************************************************************************************************
 * A simple datatype class for holding address information. This contains only getters (all setting
 * is done via the constructor) but provides a standard format for encapsulation. The constrcutor has:
 * @param Address Line One
 * @param Address Line Two
 * @param Address Line Three
 * @param Address City
 * @param Address State
 * @param Address Zip
 New addition:  isApartment boolean to distinguish apartments
 *@param Apartment
 **************************************************************************************************/
    com.qas.Address = function(lineone, linetwo, linethree, city, state, zip, apartment, DPVStatus) {
        this.lineone = lineone;
        this.linetwo = linetwo;
        this.linethree = linethree;
        this.city = city;
        this.state = state;
        this.zip = zip;
        this.apartment = apartment;
        this.DPVStatus = DPVStatus;
    };

    com.qas.Address.prototype =
{
    getLineOne: function() {
        return this.lineone;
    },

    getLineTwo: function() {
        return this.linetwo;
    },

    getLineThree: function() {
        return this.linethree;
    },

    getCity: function() {
        return this.city;
    },

    getState: function() {
        return this.state;
    },

    getZip: function() {
        return this.zip;
    },

    isApartment: function() {
        return this.apartment;
    },

    getDPVStatus: function() {
        return this.DPVStatus;
    }
};

    /** ************************************************************************************************
 * A simple datatype class for holding multiple information. Simplar to the address class above,
 * all setting is done through the constructor - only getters are available methods. Constrcutor has:
 * @param Address Text
 * @param Postcode
 * @param Moniker
 * @param Whether this is a full address or not
 * @param Score
 **************************************************************************************************/
    com.qas.PartialResult = function(addresstext, postcode, moniker, is_full_address, score, is_unresolvablerange) {
        this.addresstext = addresstext;
        this.postcode = postcode;
        this.moniker = moniker;
        this.is_full_address = is_full_address;
        this.score = score;
        this.is_unresolvablerange = is_unresolvablerange;
    };

    com.qas.PartialResult.prototype =
{
    getAddressText: function() {
        return this.addresstext;
    },

    getPostcode: function() {
        return this.postcode;
    },

    getMoniker: function() {
        return this.moniker;
    },

    getScore: function() {
        return this.score;
    },

    isFullAddress: function() {
        return this.is_full_address;
    },

    isUnresolvableRange: function() {
        return this.is_unresolvablerange;
    }
};

    /** ************************************************************************************************
 * This is the main point of interaction with the server. All searches are made through this class.
 * Users are able to perform a standard search, a refine or a format of the information. The class
 * has no state. The constructor has:
 * @param The function to call on a successful HTTP call
 * @param The function to call in the event of an error
 **************************************************************************************************/
    com.qas.SearchService = function(onLoad, onError) {
        this.onLoad = onLoad;
        this.onError = onError;
    };

    com.qas.SearchService.prototype =
{
    search: function(lone, ltwo, city, state, zip) {
        // Create the parameters to send
        var params = new com.qas.AjaxParameters();
        params.addParameter('action', 'search');
        params.addParameter('country', QasElementService.getCountrySet());
        params.addParameter('promptset', com.qas.PROMPTSET);
        params.addParameter('addlayout', QasElementService.getAddressLayout());
        params.addParameter('searchstring', events.CanURLFunction(lone) + '|' + ltwo + '|' +
            '' + '|' + city + '|' + state + '|' + zip);

        new com.qas.ContentLoader(this.onLoad, this.onError, 'POST', params);
    },

    refine: function(moniker, refinetext) {
        // Create the parameters to send
        var params = new com.qas.AjaxParameters();

        params.addParameter('action', 'refine');
        params.addParameter('country', QasElementService.getCountrySet());
        params.addParameter('moniker', moniker);
        params.addParameter('refinetext', refinetext);
        params.addParameter('addlayout', QasElementService.getAddressLayout());

        var loader = new com.qas.ContentLoader(this.onLoad, this.onError, 'POST', params);
    },

    format: function(moniker) {
        // Create the parameters to send
        var params = new com.qas.AjaxParameters();
        params.addParameter('action', 'format');
        params.addParameter('country', QasElementService.getCountrySet());
        params.addParameter('addlayout', QasElementService.getAddressLayout());
        params.addParameter('moniker', moniker);

        var loader = new com.qas.ContentLoader(this.onLoad, this.onError, 'POST', params);
    }
};

    /** ************************************************************************************************
 * Functions that implement business logic. All of them have the "business" prefix. However, they
 * are NOT objects as understood above, but rather just a collection of functions.
 **************************************************************************************************/

    /** ************************************************************************************************
 * Processes the search results - in almost all situations when a search is performed this is called
 * on success as a central decision/ logic point. What to do is dependent of the verify level that
 * is returned by the QAS engine.
 **************************************************************************************************/
    business.processSearchResults = function(interaction) {
        var previous_verify_level = verify_level;
        var previous_moniker = current_moniker;

        if (this.req.responseXML === null) {
            verify_level = 'None';
        } else {
            verify_level = this.req.responseXML.getElementsByTagName('verifylevel')[0].firstChild.nodeValue;
        }

        // convert GBR and SGP PremisesPartial and StreetPartial interactions to Multiple
        if ((QasElementService.getCountrySet() == 'GBR' || QasElementService.getCountrySet() == 'SGP') && (verify_level == 'PremisesPartial' || verify_level == 'StreetPartial')) {
            verify_level = 'Multiple';
        }

        if (verify_level == 'Verified') {
            var sDPVStatus = this.req.responseXML.getElementsByTagName('DPVStatus')[0].firstChild.nodeValue;
            if (verify_level == 'Verified' && QasElementService.getDpvInteractive() == 'true' && sDPVStatus == 'DPVNotConfirmed') {
                verify_level = 'StreetPartial';
            }
            if (verify_level == 'Verified' && QasElementService.getDpvInteractive() == 'true' && sDPVStatus == 'DPVConfirmedMissingSec') {
                verify_level = 'InteractionRequired';
            }
        }

        if (interaction_verified == true) {
            verify_level = 'Verified';
        }

        if (verify_level == 'InteractionRequired' && previous_verify_level == 'PremisesPartial') {
            verify_level = 'Verified';
        }

        if (verify_level == 'InteractionRequired' && previous_verify_level == 'StreetPartial') {
            verify_level = 'Verified';
        }

        if (verify_level == 'InteractionRequired') {
            var interResult = business.parseSingleResult(this.req);
            if (events.checkForBldg(interResult.getLineOne()) == true) {
                verify_level = 'Verified';
            }
        }


        //  Check for a multiple result with unresolvable ranges - need to prompt for street number
        var j = 0;
        var i = 0;

        if (verify_level == 'Multiple') {
            var tempresults = business.parsePicklistResults(this.req);
            for (i=0; i<tempresults.length; i++) {
                if (tempresults[i].isUnresolvableRange().toLowerCase() == 'true') {
                    j++;
                }
            }
            if (j > 0) {
                verify_level = 'StreetPartial';
            }
        }

        switch (verify_level) {
        case 'PremisesPartial':

            var results = business.parsePicklistResults(this.req);
            // If the result is single, force an interaction
            if (results[0].isFullAddress().toLowerCase() == 'true') {
                if (results.length == 1) {
                    var sservice = new com.qas.SearchService(
                        business.processForcedInteraction,
                        business.processSearchError);
                    sservice.refine(results[0].getMoniker(), '');
                    return;
                }
            }

            window['interface'].showPremPartialResults(business.parsePicklistResults(this.req));

            //  Check for a refine error and display message
            current_moniker = results[0].getMoniker();
            if (previous_moniker == current_moniker) {
                window['interface'].showRefineError();
            }

            break;
        case 'StreetPartial':
            var results = business.parsePicklistResults(this.req);
            // If the result is single, force an interaction
            if (results.length == 1 && results[0].isFullAddress().toLowerCase() == 'true') {
                var sservice = new com.qas.SearchService(
                    business.processForcedInteraction,
                    business.processSearchError);
                sservice.refine(results[0].getMoniker(), '');
                return;
            }
            /* if (previous_verify_level == verify_level && results.length > 1)
            {
                window["interface"].showStreetPartialError();
                return;
            }*/
            window['interface'].showStreetPartialResults(business.parsePicklistResults(this.req));
            break;
        case 'Verified':
            is_verified = true;
            window['interface'].showVerifiedResults(business.parseSingleResult(this.req));
            /* window["interface"].appendApt(business.parseSingleResult(this.req));
            events.handleThirdPartyButtonClick();
            interaction_verified = "";
            $("#"+qas.QASWIDGET).slideUp();
            $("#"+qas.QASWRAPPERDIV).slideDown();
            qas.CALLBACK();*/
            break;
        case 'InteractionRequired':
            window['interface'].showInteractionResults(business.parseSingleResult(this.req));
            break;
        case 'Multiple':
            window['interface'].showMultipleResults(business.parsePicklistResults(this.req));
            break;
        case 'None':
            if (QasElementService.getIgnoreUnmatchedAddresses().toLowerCase() == 'true') {
                window['interface'].showVerifiedResults(originaladdress);
                events.submitForm();
            } else {
                window['interface'].showNoResults();
            }
            break;
        default:
            break;
        }
    };

    /** ************************************************************************************************
 * This takes the XML result from the HTTP call and wraps it in an array of  partial classes .
 **************************************************************************************************/
    business.parsePicklistResults = function(req) {
        var results = new Array();
        var picklistitems = req.responseXML.getElementsByTagName('picklistitem');
        for (var i = 0; i < picklistitems.length; i++) {
            var prempartial = new com.qas.PartialResult(
                picklistitems[i].getElementsByTagName('addresstext')[0].firstChild.nodeValue,
                (picklistitems[i].getElementsByTagName('postcode')[0].firstChild != null) ? picklistitems[i].getElementsByTagName('postcode')[0].firstChild.nodeValue : '',
                picklistitems[i].getElementsByTagName('moniker')[0].firstChild.nodeValue,
                picklistitems[i].getElementsByTagName('fulladdress')[0].firstChild.nodeValue,
                picklistitems[i].getElementsByTagName('score')[0].firstChild.nodeValue,
                picklistitems[i].getElementsByTagName('unresolvablerange')[0].firstChild.nodeValue);
            if (typeof prempartial !== 'undefined' && prempartial !== null) {
                results[i] = prempartial;
            } else {
                results[i] = {};
            }
        }
        return results;
    };

    /** ************************************************************************************************
 * This takes the XML result from the HTTP and wraps it in an address class.
 (req.responseXML.getElementsByTagName("linetwo")[0].firstChild != null) ? req.responseXML.getElementsByTagName("linetwo")[0].firstChild.nodeValue : "",
 **************************************************************************************************/

    business.parseSingleResult = function(req) {
        var sAdd1 = '';
        if (req.responseXML.getElementsByTagName('lineone')[0].firstChild != null) {
            sAdd1 = req.responseXML.getElementsByTagName('lineone')[0].firstChild.nodeValue;
        }
        var sAdd2 = '';
        if (req.responseXML.getElementsByTagName('linetwo')[0].firstChild != null) {
            sAdd2 = req.responseXML.getElementsByTagName('linetwo')[0].firstChild.nodeValue;
        }
        var sAdd3 = '';
        if (req.responseXML.getElementsByTagName('linethree')[0].firstChild != null) {
            sAdd3 = req.responseXML.getElementsByTagName('linethree')[0].firstChild.nodeValue;
        }
        var sCity = '';
        if (req.responseXML.getElementsByTagName('city')[0].firstChild != null) {
            sCity = req.responseXML.getElementsByTagName('city')[0].firstChild.nodeValue;
        }
        var sState = '';
        if (req.responseXML.getElementsByTagName('state')[0].firstChild != null) {
            sState = req.responseXML.getElementsByTagName('state')[0].firstChild.nodeValue;
        }
        var sZIP = '';
        if (req.responseXML.getElementsByTagName('zip')[0].firstChild != null) {
            sZIP = req.responseXML.getElementsByTagName('zip')[0].firstChild.nodeValue;
        }
        var sApt = '';
        if (req.responseXML.getElementsByTagName('apartment')[0].firstChild != null) {
            sApt = req.responseXML.getElementsByTagName('apartment')[0].firstChild.nodeValue;
        }
        var sDPVStatus = '';
        if (req.responseXML.getElementsByTagName('DPVStatus')[0].firstChild != null) {
            sDPVStatus = req.responseXML.getElementsByTagName('DPVStatus')[0].firstChild.nodeValue;
        }

        if (sAdd1 == '') {
            sAdd1 = sAdd2;
            sAdd2 = sAdd3;
            if (sAdd1 == '' && sAdd2 != '') {
                sAdd1 = sAdd2;
                sAdd2 = '';
            }
        }
        if (sAdd2 == '' && sAdd3 != '') {
            sAdd2 = sAdd3;
            sAdd3 = '';
        }
        return new com.qas.Address(sAdd1, sAdd2, sAdd3, sCity, sState, sZIP, sApt, sDPVStatus);
    };

    /** ************************************************************************************************
 * If the result is a single record premesis partial or a street partial, then display the record
 * as an interaction required.
 **************************************************************************************************/
    business.processForcedInteraction = function() {
        window['interface'].showInteractionResults(business.parseSingleResult(this.req));
    };

    /** ************************************************************************************************
 * Standard method for handling a search error. Note that if the user has chosen to ignore this
 * error (by setting IGNORE_CONNECTION_ERROR, then the method simply submits the form.
 **************************************************************************************************/
    business.processSearchError = function() {
        if (QasElementService.getIgnoreConnectionError().toLowerCase() == 'true') {
            var continueButton = document.getElementById(QasElementService.getFormButtonId());
            if (continueButton) {
                continueButton.onclick = function() {
                    return true;
                };
                continueButton.click();
                document.forms[0].submit();
            }
        } else {
            var errorMsg = ('An error has occurred. Please check the settings in the '
            + 'file proweb.htm and ensure that the server is running correctly (you '
            + 'can run test_server_setup to check.');

            window['interface'].inlineError(errorMsg);

            // Try to remove wait_wgt if it is a child.
            try {
                document.body.removeChild(document.getElementById('wait_wgt'));
            } catch (e) {}
        //       document.getElementById("cover_wgt").style.display = "none";
        }
    };

    /** ************************************************************************************************
 * If the user has entered an incorrect refine range, this method is called.
 **************************************************************************************************/
    business.processRefineError = function() {
        window['interface'].showRefineError();
    };

    /** ************************************************************************************************
 * This method decides which button to display (if the user has specified a form button on the
 * html).
 **************************************************************************************************/
    business.selectInputButton = function() {
        if (QasElementService.getFormButtonId().length > 0) {
            var button = document.getElementById(QasElementService.getFormButtonId());
        }
    };

    /** ************************************************************************************************
 * All event handling methods. Events is not an class, simply a collection of functions.
 **************************************************************************************************/

    /** ************************************************************************************************
 * When the original form button is clicked to start the verification/ form submission. This starts
 * a basic search with the values in the text input fields.
 **************************************************************************************************/
    events.handleClickInputButton = function(qasAddress, accountConfigManager) {
        events.setMessages();

        self.accountConfigManager = accountConfigManager;

        var lone = qasAddress.addressLine1;
        var ltwo = qasAddress.addressLine2;
        var lthree = qasAddress.addressLine3 || '';
        var city = qasAddress.city;
        var state = qasAddress.state;
        var zip = qasAddress.zip;

        originaladdress = new com.qas.Address(lone, ltwo, lthree, city, state, zip);

        var sservice = new com.qas.SearchService(
            business.processSearchResults,
            business.processSearchError);

        sservice.search(lone, ltwo, city, state, zip);
    };

    /** ************************************************************************************************
 * When the refine button is clicked from the refine widget
 **************************************************************************************************/
    events.handleClickRefineButton = function(evt) {
        if (document.getElementById('refine_input').value.length <= 0) {
            var errorMsg = ('Please enter refinement text');
            window['interface'].inlineError(errorMsg);

            return;
        }

        var sservice = new com.qas.SearchService(
            business.processSearchResults,
            business.processRefineError);
        sservice.refine(
            document.getElementById('refine_moniker').value,
            document.getElementById('refine_input').value);
    };

    /** ************************************************************************************************
 * Event called when a multiple result link is clicked (forces a refine of the result)
 **************************************************************************************************/
    events.handleClickMultipleButton = function(evt) {
        var sservice = new com.qas.SearchService(
            business.processSearchResults,
            business.processSearchError);
        sservice.refine(this.getAttribute('moniker'), '');
    };

    /** ************************************************************************************************
 * Event called when the premises partial button is clicked (starts a search with an "apt" appendage)
 **************************************************************************************************/
    events.handleClickPremPartialButton = function(evt) {
        var lone = document.forms[qas.FORMNAME][LINEONECTL].value + ' apt ' +
        document.getElementById('partial_input').value;
        var ltwo = document.forms[qas.FORMNAME][LINETWOCTL].value;
        var lthree = '';
        if (document.forms[qas.FORMNAME][LINETHREECTL]) {
            lthree = document.getElementById(LINETHREECTL).value;
        }
        var city = document.forms[qas.FORMNAME][CITYCTL].value;
        var state = document.forms[qas.FORMNAME][STATECTL].value;
        var zip = document.forms[qas.FORMNAME][ZIPCTL].value;
        var sservice = new com.qas.SearchService(
            business.processSearchResults,
            business.processSearchError);
        sservice.search(lone, ltwo, lthree, city, state, zip);
    };

    /** ************************************************************************************************
 * Event called when the street partial button is clicked (deals with urbanizations amongsth others)
 **************************************************************************************************/
    events.handleClickStreetPartialButton = function(evt) {
        var lone = document.forms[qas.FORMNAME][LINEONECTL].value;
        var ltwo = document.forms[qas.FORMNAME][LINETWOCTL].value;

        var urbregex = new RegExp('^(urb|urbanisation|urbanizaciï¿½n)', 'i');
        if (urbregex.exec(document.forms[qas.FORMNAME][LINEONECTL].value) != null) {
            ltwo = document.getElementById('partial_input').value + ' ' + ltwo;
            document.forms[qas.FORMNAME][LINETWOCTL].value = ltwo;
        } else {
            lone = document.getElementById('partial_input').value + ' '
            + lone.replace(/^[0-9]+/, '');
            document.forms[qas.FORMNAME][LINEONECTL].value = lone;
        }

        var lthree = '';
        if (document.forms[qas.FORMNAME][LINETHREECTL]) {
            lthree = document.getElementById(LINETHREECTL).value;
        }
        var city = document.forms[qas.FORMNAME][CITYCTL].value;
        var state = document.forms[qas.FORMNAME][STATECTL].value;
        var zip = document.forms[qas.FORMNAME][ZIPCTL].value;
        var sservice = new com.qas.SearchService(
            business.processSearchResults,
            business.processSearchError);
        sservice.search(lone, ltwo, lthree, city, state, zip);
    };

    /** ************************************************************************************************
 * Event called when links from either prem or street partial results are clicked (calls refine)
 **************************************************************************************************/
    events.handleClickPartialText = function(evt) {
        var sservice = new com.qas.SearchService(
            business.processSearchResults,
            business.processSearchError);

        sservice.refine(this.getAttribute('moniker'), '');
    };

    /** ************************************************************************************************
 * Event called when button clicked from the interaction widget
 **************************************************************************************************/
    events.handleClickInteractionButton = function(evt) {
        document.forms[qas.FORMNAME][LINEONECTL].value = finaladdress.getLineOne();
        document.forms[qas.FORMNAME][LINETWOCTL].value = finaladdress.getLineTwo();
        if (document.forms[qas.FORMNAME][LINETHREECTL]) {
            document.getElementById(LINETHREECTL).value = finaladdress.getLineThree();
        }
        document.forms[qas.FORMNAME][CITYCTL].value = finaladdress.getCity();
        document.forms[qas.FORMNAME][STATECTL].value = finaladdress.getState();
        document.forms[qas.FORMNAME][ZIPCTL].value = finaladdress.getZip();
        verify_level = 'none';
        window['interface'].clearNonVerifiedWidgets();
        com.qas.BYPASS_QAS_VERIFICATION = true;
        $('#'+qas.QASWIDGET).slideUp();
        $('#'+qas.QASWRAPPERDIV).slideDown();
        qas.CALLBACK();
    };

    /** ************************************************************************************************
 * Event when the users click "choose this address" from the right hand details widget.
 **************************************************************************************************/
    events.handleChooseAddressText = function(evt) {
        verify_level = 'none';
        window['interface'].clearNonVerifiedWidgets();
        com.qas.BYPASS_QAS_VERIFICATION = true;
        $('#' + qas.QASWIDGET).slideUp();
        $('#' + qas.QASWRAPPERDIV).slideDown();
        qas.CALLBACK();
    };

    /** ************************************************************************************************
 * Event when the user clicks "edit this address" from the right hand details widget.
 **************************************************************************************************/
    events.handleEditAddressText = function(evt) {
        verify_level = '';
        current_moniker = '';
        //  window["interface"].clearNonVerifiedWidgets();
        $('#' + qas.QASWIDGET).slideUp();
        $('#' + qas.QASWRAPPERDIV).slideDown();
        $('#' + qas.QASWRAPPERDIV).show();
        document.getElementById('wait_wgt').style.display = 'none';
        //   window["interface"].manageSelectFields("");
        try {
            $('#qasWarning').remove($('interaction_details'));
        } catch (Exception) {}
    };

    /** ************************************************************************************************
 * This function actually is a response to any event wanting to submit the form in question. It is
 * required as well as the function below because users may wish to ignore unmatched addresses.
 **************************************************************************************************/
    events.submitForm = function(evt) {
    // If we are not in a form, then do not do anything (there is no third party button)
        if (QasElementService.getFormButtonId().length <= 0 || document.getElementById(QasElementService.getFormButtonId()) == null) {
            return;
        }

        document.getElementById(QasElementService.getFormButtonId()).onclick =
        function() {
            return true;
        };
        document.getElementById(QasElementService.getFormButtonId()).click();
    };

    /** ************************************************************************************************
 * When the user click the form button, this method decides what to do. It first runs any javascript
 * already associated with the button click event. Once that has run successfully (returned true)
 * then it runs the address verification. If it happy that the address is verified (or that the user
 * does not want to verify), then it submit the form.
 **************************************************************************************************/
    events.handleThirdPartyButtonClick = function(evt) {
    // If we are not in a form, then do not do anything (there is no third party button)
        if (QasElementService.getFormButtonId().length <= 0 || document.getElementById(QasElementService.getFormButtonId()) == null) {
            return true;
        }

        // If an error should be ignored, submit the form anyway
        if ((QasElementService.getIgnoreConnectionError().toLowerCase() == 'true')
        && (verify_level.toLowerCase() == 'none')) {
            document.getElementById(QasElementService.getFormButtonId()).onclick = existing_button_onclick;
            document.getElementById(QasElementService.getFormButtonId()).click();
        }

        // If we are on the first page, run the inital javascript for the page. If that
        // completes, run the QAS code
        if ((current_widget == 'input_wgt') && (is_verified != true)) {
        // Run the existing code for the onclick event, but catch the return
            var return_button;
            try {
                return_value = existing_button_onclick();
            } catch (err) {
                return_value = eval(existing_button_onclick.replace(/(^|;| )return /i, ''));
            }

            if (return_value == true || return_value == null) {
            // If the user has chosen to bypass qas, reset the button and click
                if (document.getElementById('BYPASS_QAS_VERIFICATION').value.toLowerCase() == 'true') {
                    return true;
                }

                events.handleClickInputButton();
            }
            return false;
        } else if ((current_widget == 'input_wgt') && (is_verified == true)) {
            document.getElementById(QasElementService.getFormButtonId()).click();
            return true;
        } else {
            return false;
        }
    };

    /** ************************************************************************************************
 * This event acts as a general onKeyPress event for those input boxes that submit a widget when
 * the return key is pressed.
 **************************************************************************************************/
    events.handleSubmitOnEnterKey = function(evt) {
        var button;
        if (current_widget == 'refine_wgt') {
            button = document.getElementById('refine_btnsubmit');
        } else {
            button = document.getElementById('partial_btnsubmit');
        }

        // Deal with browser incompatibility
        if (window.event == null) {
            if (evt && evt.keyCode == 13) {
                button.click();
            }
        } else {
            if (window.event && window.event.keyCode == 13) {
                button.click();
            }
        }
    };

    /** ************************************************************************************************
 * As well as the above, this form ensures that, when return is pressed by the user, the document/
 * form is not also submitted (i.e problem only)
 **************************************************************************************************/
    events.preventSubmissionFormEnter = function(evt) {
    // Deal with browser incompatibility
        if (window.event == null) {
            return !(evt && evt.keyCode == 13);
        } else {
            return !(window.event && window.event.keyCode == 13);
        }
    };
    /** ************************************************************************************************
 *Check for "-" to determine if there is an apartment
 **************************************************************************************************/
    events.checkForApt = function(address) {
        var bool = false;

        var linetwo = address.getLineTwo();

        for (var i=0; i<linetwo.length; i++) {
            if (linetwo.charAt(i) == '-') {
                bool=true;
            }
        }
        return bool;
    };
    /** ************************************************************************************************
 * Appends the apartment to the front of the address
 *Test
 **************************************************************************************************/
    events.appendApt = function() {
        var holder1 = document.forms[qas.FORMNAME][LINEONECTL].value;
        var holder2 = document.forms[qas.FORMNAME][LINETWOCTL].value;
        var apt = document.getElementById('apt_input').value;
        if (events.checkForBldg(holder1) == true) {
            document.forms[qas.FORMNAME][LINEONECTL].value = apt + '-' + holder2;
            document.forms[qas.FORMNAME][LINETWOCTL].value = '';
        } else {
            document.forms[qas.FORMNAME][LINETWOCTL].value = apt + '-' + holder2;
        }
        window['interface'].selectDisplay('input_wgt');
    };
    /** ************************************************************************************************
 * handles if the user doesn't want to enter an apartment when suggested
 *Test
 **************************************************************************************************/
    events.handleNoApt = function() {
        var holder1 = document.forms[qas.FORMNAME][LINEONECTL].value;
        var holder2 = document.forms[qas.FORMNAME][LINETWOCTL].value;
        if (events.checkForBldg(holder1) == true) {
            document.forms[qas.FORMNAME][LINEONECTL].value = holder2;
            document.forms[qas.FORMNAME][LINETWOCTL].value = '';
        }
        window['interface'].selectDisplay('input_wgt');
    };
    /** ************************************************************************************************
 *Check for a common building name to determine if there is an apartment
 **************************************************************************************************/
    events.checkForBldg = function(address) {
        var bool = false;
        if (address == 'Business') {
            bool = true;
        }
        if (address == 'Building') {
            bool = true;
        }
        if (address == 'Bldg') {
            bool = true;
        }
        if (address == 'Business Bldg') {
            bool = true;
        }
        if (address == 'Business Bldg.') {
            bool = true;
        }
        if (address == 'Business Building') {
            bool = true;
        }
        if (address == 'Business Complex') {
            bool = true;
        }
        if (address == 'Business Plaza') {
            bool = true;
        }
        if (address == 'Immeuble Commercial') {
            bool = true;
        }
        if (address == 'Apt') {
            bool = true;
        }
        if (address == 'Apartment') {
            bool = true;
        }
        if (address == 'Apartment Bldg') {
            bool = true;
        }
        if (address == 'Apartment Bldg.') {
            bool = true;
        }
        if (address == 'Apartment Building') {
            bool = true;
        }
        if (address == 'Immeuble a Appartements') {
            bool = true;
        }
        if (address == 'Townhomes') {
            bool = true;
        }
        if (address == 'Townhouses') {
            bool = true;
        }

        return bool;
    };

    events.CanURLFunction = function(sString) {
        var sOutput='';
        sOutput = sString.replace(/&/gi, '%38');
        sOutput = sOutput.replace(/&amp;/gi, '%38');
        sOutput = sOutput.replace(/&frasl;/gi, '%47');
        sOutput = sOutput.replace(/ï¿½/gi, '%191');
        sOutput = sOutput.replace(/ï¿½/gi, '%192');
        sOutput = sOutput.replace(/ï¿½/gi, '%193');
        sOutput = sOutput.replace(/ï¿½/gi, '%194');
        sOutput = sOutput.replace(/ï¿½/gi, '%195');
        sOutput = sOutput.replace(/ï¿½/gi, '%196');
        sOutput = sOutput.replace(/ï¿½/gi, '%197');
        sOutput = sOutput.replace(/ï¿½/gi, '%198');
        sOutput = sOutput.replace(/ï¿½/gi, '%199');
        sOutput = sOutput.replace(/ï¿½/gi, '%200');
        sOutput = sOutput.replace(/ï¿½/gi, '%201');
        sOutput = sOutput.replace(/ï¿½/gi, '%202');
        sOutput = sOutput.replace(/ï¿½/gi, '%203');
        sOutput = sOutput.replace(/ï¿½/gi, '%204');
        sOutput = sOutput.replace(/ï¿½/gi, '%205');
        sOutput = sOutput.replace(/ï¿½/gi, '%206');
        sOutput = sOutput.replace(/ï¿½/gi, '%207');
        sOutput = sOutput.replace(/ï¿½/gi, '%208');
        sOutput = sOutput.replace(/ï¿½/gi, '%209');
        sOutput = sOutput.replace(/ï¿½/gi, '%210');
        sOutput = sOutput.replace(/ï¿½/gi, '%211');
        sOutput = sOutput.replace(/ï¿½/gi, '%212');
        sOutput = sOutput.replace(/ï¿½/gi, '%213');
        sOutput = sOutput.replace(/ï¿½/gi, '%214');
        sOutput = sOutput.replace(/ï¿½/gi, '%216');
        sOutput = sOutput.replace(/ï¿½/gi, '%218');
        sOutput = sOutput.replace(/ï¿½/gi, '%219');
        sOutput = sOutput.replace(/ï¿½/gi, '%220');
        sOutput = sOutput.replace(/ï¿½/gi, '%221');
        sOutput = sOutput.replace(/ï¿½/gi, '%222');
        sOutput = sOutput.replace(/ï¿½/gi, '%223');
        sOutput = sOutput.replace(/ï¿½/gi, '%224');
        sOutput = sOutput.replace(/ï¿½/gi, '%225');
        sOutput = sOutput.replace(/ï¿½/gi, '%226');
        sOutput = sOutput.replace(/ï¿½/gi, '%227');
        sOutput = sOutput.replace(/ï¿½/gi, '%228');
        sOutput = sOutput.replace(/ï¿½/gi, '%229');
        sOutput = sOutput.replace(/ï¿½/gi, '%230');
        sOutput = sOutput.replace(/ï¿½/gi, '%231');
        sOutput = sOutput.replace(/ï¿½/gi, '%232');
        sOutput = sOutput.replace(/ï¿½/gi, '%233');
        sOutput = sOutput.replace(/ï¿½/gi, '%234');
        sOutput = sOutput.replace(/ï¿½/gi, '%235');
        sOutput = sOutput.replace(/ï¿½/gi, '%236');
        sOutput = sOutput.replace(/ï¿½/gi, '%237');
        sOutput = sOutput.replace(/ï¿½/gi, '%238');
        sOutput = sOutput.replace(/ï¿½/gi, '%239');
        sOutput = sOutput.replace(/ï¿½/gi, '%240');
        sOutput = sOutput.replace(/ï¿½/gi, '%241');
        sOutput = sOutput.replace(/ï¿½/gi, '%242');
        sOutput = sOutput.replace(/ï¿½/gi, '%243');
        sOutput = sOutput.replace(/ï¿½/gi, '%244');
        sOutput = sOutput.replace(/ï¿½/gi, '%244');
        sOutput = sOutput.replace(/ï¿½/gi, '%245');
        sOutput = sOutput.replace(/ï¿½/gi, '%246');
        sOutput = sOutput.replace(/ï¿½/gi, '%248');
        sOutput = sOutput.replace(/ï¿½/gi, '%249');
        sOutput = sOutput.replace(/ï¿½/gi, '%250');
        sOutput = sOutput.replace(/ï¿½/gi, '%251');
        sOutput = sOutput.replace(/ï¿½/gi, '%252');
        sOutput = sOutput.replace(/ï¿½/gi, '%253');
        sOutput = sOutput.replace(/ï¿½/gi, '%254');
        sOutput = sOutput.replace(/ï¿½/gi, '%255');
        return sOutput;
    };

    window['interface'].appendApt = function(address) {
        var holder2 = document.forms[qas.FORMNAME][LINEONECTL].value;
        var $qasWarning = $('#qasWarning');
        if ((events.checkForApt(address) == false) && (address.isApartment().toLowerCase() == 'true') && (QasElementService.getCountrySet() == 'CAN')) {
            $qasWarning.empty();

            var header = document.createElement('H2');
            header.innerHTML = com.qas.MSG_HEADER;
            $qasWarning.append(header);

            var message = document.createElement('div');
            message.setAttribute('id', 'none_message');
            message.innerHTML = com.qas.MSG_APPENDAPT;
            message.className = 'alert-box secondary';
            $qasWarning.empty();
            $qasWarning.append(message);

            window['interface'].showRightDetails('qasWarning');

            var correctyouraddress = document.createElement('dt');
            correctyouraddress.className = 'qas_message_large';
            correctyouraddress.innerHTML = '<BR>&nbsp;&nbsp;&nbsp;&nbsp;' + 'Confirm Apt/Ste';
            $qasWarning.append(correctyouraddress);

            var label = document.createElement('label');
            label.setAttribute('class', 'qas_message_small');
            label.innerHTML = '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;';
            $qasWarning.append(label);

            var input = document.createElement('input');
            input.setAttribute('type', 'input');
            input.setAttribute('id', 'apt_input');
            input.setAttribute('value', '');
            input.className = 'qas_refinefield';
            input.onkeypress = events.handleSubmitOnEnterKey;
            $qasWarning.append(input);

            var button = document.createElement('input');
            button.setAttribute('type', 'button');
            button.setAttribute('id', 'partial_btnsubmit');
            button.setAttribute('value', 'Continue');
            button.className = 'qas_refinebutton';
            button.onclick = events.appendApt;
            $qasWarning.append(button);

            var noapt = document.createElement('dt');
            noapt.className = 'qas_link';
            noapt.innerHTML = 'I don\'t have an apt or suite';
            noapt.onclick = events.handleNoApt;
            $qasWarning.append(noapt);

            window['interface'].selectDisplay('qasWarning');
            document.getElementById('apt_input').focus();
        }
        /* replaced checkforapt(address) with checkforbldg*/
        else if (events.checkForBldg(holder2) == true) {
            var holder = document.forms[qas.FORMNAME][LINETWOCTL].value;
            document.forms[qas.FORMNAME][LINEONECTL].value = holder;
            document.forms[qas.FORMNAME][LINETWOCTL].value = '';
        }
    };

    /** ************************************************************************************************
 * Display a fully verified result in the original input fields (or an unverified address if the
 * setting is that the address need not be verified).
 **************************************************************************************************/
    window['interface'].showVerifiedResults = function(address) {
    // Remove all other HTML for the form submission
    /* window["interface"].clearNonVerifiedWidgets();

    document.getElementById("QASMatched").value = is_verified;
    document.forms[qas.FORMNAME][LINEONECTL].value = address.getLineOne();
    document.forms[qas.FORMNAME][LINETWOCTL].value = address.getLineTwo();
    document.forms[qas.FORMNAME][CITYCTL].value = address.getCity();
    document.forms[qas.FORMNAME][STATECTL].value = address.getState();
    document.forms[qas.FORMNAME][ZIPCTL].value = address.getZip();*/
    
    // alert("VerifiedAddress");
        qas.CALLBACK(address);
    };

    /** ************************************************************************************************
 * Displays all multiple results (as a list of links)
 **************************************************************************************************/
    window['interface'].showMultipleResults = function(results) {
    /* var $qasWarning = $("#qasWarning");
    document.getElementById("multiple_wgt").innerHTML = "";

    var header = document.createElement("dt");
    header.className = "qas_header";
    header.innerHTML = com.qas.MSG_HEADER;
    $qasWarning.append(header);

    var message = document.createElement("dt");
    message.innerHTML = com.qas.MSG_MULITPLE;
    message.className = "qas_message";
    $qasWarning.empty();
    $qasWarning.append(message);

    window["interface"].showRightDetails("qasWarning");

    var title = document.createElement("dt");
    title.className = "qas_message_prompt";
    title.innerHTML = "<BR>&nbsp;&nbsp;&nbsp;&nbsp;Our suggested matches:<BR><BR>";
    //title.className = "qas_title";
    $qasWarning.append(title);

    for(var i = 0; i < results.length; i++)
    {
        result = document.createElement("dt");
        result.setAttribute("moniker", results[i].getMoniker());

        if (results[i].getAddressText().length >= 45)
        {
            result.innerHTML = results[i].getAddressText().substr(0,45) + "..." +
                "<label class='qas_postcode'>" + results[i].getPostcode() + "</label>";
        }
        else
        {
            result.innerHTML = results[i].getAddressText() +
                "<label class='qas_postcode'>" + results[i].getPostcode() + "</label>";
        }

        if (results[i].isFullAddress().toLowerCase() == "true")
        {
            result.className = "qas_link_small";
            result.onclick = events.handleClickMultipleButton;
        }
        else
        {
            result.className = "qas_link";
        }

        $qasWarning.append(result);
    }
    window["interface"].selectDisplay("qasWarning");
    */
        var addresses = [];
        var address = {};
        for (var i = 0; i < results.length; i++) {   
            address = {};
            address.moniker = results[i].getMoniker();

            address.addressText = results[i].getAddressText() + results[i].getPostcode();

            if (null != results[i].getAddressText() && undefined != results[i].getAddressText() && results[i].getAddressText().indexOf('..') === -1) {
                addresses.push(address);
            }
        }
        if (addresses.length == 0) {
            window['interface'].showNoResults();
        }
        qas.CALLBACK(addresses);
    };

    /** ************************************************************************************************
 * Show the premises partial results
 **************************************************************************************************/
    window['interface'].showPremPartialResults = function(results) {
        /* window["interface"].showPartialResults(
        results, events.handleClickPremPartialButton,
        com.qas.MSG_PREMPARTIAL, "Confirm your Apartment/Suite/Unit number:");*/
        var addresses = [];
        var address = {};
        for (var i = 0; i < results.length; i++) {   
            address = {};
            address.moniker = results[i].getMoniker();


            address.addressText = results[i].getAddressText() + results[i].getPostcode();

            if (null != results[i].getAddressText() && undefined != results[i].getAddressText() && results[i].getAddressText().indexOf('..') === -1) {
                addresses.push(address);
            }
        }
        if (addresses.length == 0) {
            window['interface'].showNoResults();
        }
        qas.CALLBACK(addresses);
    };

    /** ************************************************************************************************
 * Show the street partial results
 **************************************************************************************************/
    window['interface'].showStreetPartialResults = function(results) {
    /* window["interface"].showPartialResults(
        results, events.handleClickStreetPartialButton,
        com.qas.MSG_STREETPARTIAL, "Confirm your House/Building number:");*/
        var addresses = [];
        var address = {};
        for (var i = 0; i < results.length; i++) {   
            address = {};
            address.moniker = results[i].getMoniker();

            address.addressText = results[i].getAddressText() + results[i].getPostcode();

            if (null != results[i].getAddressText() && undefined != results[i].getAddressText() && results[i].getAddressText().indexOf('..') === -1) {
                addresses.push(address);
            }
        }
        if (addresses.length == 0) {
            window['interface'].showNoResults();
        }
        qas.CALLBACK(addresses);
    };

    /** ************************************************************************************************
 * because the partial (prem and street) share so much functionality, this function is used by both
 * (the results, button event, main message and label message are sent as args)
 **************************************************************************************************/
    window['interface'].showPartialResults = function(results, buttonevent, msg, label_msg) {
    /* if (results.length == 1)
    {
        window["interface"].showRefinePrompt(results[0]);
    }
    else
    {
        var $qasWarning = $("#qasWarning");
        document.getElementById("partial_wgt").innerHTML = "";

        var header = document.createElement("dt");
        header.className = "qas_header";
        header.innerHTML = com.qas.MSG_HEADER;
        $qasWarning.append(header);

        var message = document.createElement("dt");
        message.className = "qas_message";
        message.innerHTML = msg;
        $qasWarning.empty();
        $qasWarning.append(message);

        window["interface"].showRightDetails("qasWarning");


        var correctyouraddress = document.createElement("dt");
        correctyouraddress.className = "qas_message_large";
        correctyouraddress.innerHTML = "<BR>&nbsp;&nbsp;&nbsp;&nbsp;" + label_msg;
        $qasWarning.append(correctyouraddress);


        var label = document.createElement("label");
        label.setAttribute("class", "qas_message_small");
        label.innerHTML = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
        $qasWarning.append(label);

        var input = document.createElement("input");
        input.setAttribute("type", "input");
        input.setAttribute("id", "partial_input");
        input.setAttribute("value", "");
        input.className = "qas_refinefield";
        input.onkeypress = events.handleSubmitOnEnterKey;
        $qasWarning.append(input);

        var button = document.createElement("input");
        button.setAttribute("type", "button");
        button.setAttribute("id", "partial_btnsubmit");
        button.setAttribute("value", "Confirm number");
        button.className = "qas_confirmbutton";
        button.onclick = buttonevent;
        $qasWarning.append(button);

        var showlink = document.createElement("dt");
        showlink.className = "qas_link_small";
        showlink.setAttribute("id", "partial_showlink");
        showlink.innerHTML = "Display all potential matches";
        showlink.onclick = events.handleClickShowPartialResults;

        if (typeof sDPVStatus === "undefined")
        {
            $qasWarning.append(showlink);
        }

        var resultholder = document.createElement("dd");
        resultholder.setAttribute("id", "partial_allresults");
        resultholder.style.display = "none";

        for(var i = 0; i < results.length; i++)
        {
            var result = document.createElement("dt");
            result.setAttribute("moniker", results[i].getMoniker());
            result.className = "qas_previewaddress";
            result.innerHTML = results[i].getAddressText() +
                "<label class='qas_postcode'>" + results[i].getPostcode() + "</label>";
            resultholder.appendChild(result);
            if (results[i].isFullAddress().toLowerCase() == "true")
            {
                result.className = "qas_range";
                result.onclick = events.handleClickPartialText;
            }
            else
            {
                result.className = "qas_range";
            }
        }

        $qasWarning.append(resultholder);
        window["interface"].selectDisplay("qasWarning");
        document.getElementById("partial_input").focus();
    }
    */
        var addresses = [];
        var address = {};
        for (var i = 0; i < results.length; i++) {   
            if (results[i].isFullAddress().toLowerCase() == 'true') {
                address = {};
                address.moniker = results[i].getMoniker();
                address.addressText = results[i].getAddressText() + results[i].getPostcode();
        
                address.addressText = results[i].getAddressText() + results[i].getPostcode();
                if (null != results[i].getAddressText() && undefined != results[i].getAddressText() && results[i].getAddressText().indexOf('..') === -1) {
                    addresses.push(address);
                }
            }
        }
        if (addresses.length == 0) {
            window['interface'].showNoResults();
        }
        // alert(JSON.stringify(addresses));
        qas.CALLBACK(addresses);
    };

    /** ************************************************************************************************
 * This shows an address that requires confirmation/ interaction
 **************************************************************************************************/
    window['interface'].showInteractionResults = function(result) {   
        qas.CALLBACK('InteractionRequired');
        // alert("InteractionRequired");
        /* var $qasWarning = $("#qasWarning");
    document.getElementById("interaction_wgt").innerHTML = "";

    var header = document.createElement("dt");
    header.className = "qas_header";
    header.innerHTML = com.qas.MSG_HEADER;
    $qasWarning.append(header);

    var message = document.createElement("dt");
    finaladdress = result;

    if (result.getDPVStatus() == "DPVConfirmedMissingSec" && QasElementService.getDpvInteractive() == "true" && QasElementService.getCountrySet() == "USA")
    {
        message.innerHTML = com.qas.MSG_INTERACTION_DPV_FAILED;
    }
    else
    {
        message.innerHTML = com.qas.MSG_INTERACTION;
    }

    message.className = "qas_message";
    $qasWarning.empty();
    $qasWarning.append(message);

    window["interface"].showRightDetails("qasWarning");
    var standardizesmessage = document.createElement("dt");
    standardizesmessage.className = "qas_message_prompt";

    if ((result.getDPVStatus() == "DPVNotConfirmed" || result.getDPVStatus() == "DPVConfirmedMissingSec") && QasElementService.getDpvInteractive() == "true" && QasElementService.getCountrySet() == "USA")
    {
        standardizesmessage.innerHTML = qasUtil.qasMobile.formattedAddress;
    }
    else
    {
        standardizesmessage.innerHTML = qasUtil.qasMobile.suggestedMatches;
    }


    var llineone = document.createElement("input");
    llineone.setAttribute("type", "hidden");
    llineone.setAttribute("id", "interaction_lineone");
    llineone.setAttribute("value", result.getLineOne());


    var llinetwo = document.createElement("input");
    llinetwo.setAttribute("type", "hidden");
    llinetwo.setAttribute("id", "interaction_linetwo");
    llinetwo.setAttribute("value", result.getLineTwo());

    var llinethree = document.createElement("input");
    llinethree.setAttribute("type", "hidden");
    llinethree.setAttribute("id", "interaction_linethree");
    llinethree.setAttribute("value", result.getLineThree());

    var llinecity = document.createElement("input");
    llinecity.setAttribute("type", "hidden");
    llinecity.setAttribute("id", "interaction_linecity");
    llinecity.setAttribute("value", result.getCity());

    var llinestate = document.createElement("input");
    llinestate.setAttribute("type", "hidden");
    llinestate.setAttribute("id", "interaction_linestate");
    llinestate.setAttribute("value", result.getState());

    var llinezip = document.createElement("input");
    llinezip.setAttribute("type", "hidden");
    llinezip.setAttribute("id", "interaction_linezip");
    llinezip.setAttribute("value", result.getZip());

    var lone = document.createElement("dt");
    lone.className = "qas_message_left_details";

    document.getElementById("interaction_wgt").appendChild(lone);

    lone.innerHTML = "<NOBR>" + result.getLineOne() + "</NOBR><br>"
        + result.getLineTwo() + "<br>"
        + "<NOBR>" + result.getCity() + " " + result.getState() + "&nbsp;&nbsp;" + result.getZip() + "</NOBR><br><br>";


    var lapt = document.createElement("input");
    lapt.setAttribute("type", "hidden");
    lapt.setAttribute("id", "interaction_apt");
    lapt.setAttribute("value", result.isApartment());
    document.getElementById("interaction_wgt").appendChild(lapt);

    var spacing = document.createElement("dt");
    spacing.innerHTML = "<BR><BR><BR>";

    var $button = $("<button></button>");
    $button.attr("id", "partial_btnsubmit");

    if ((result.getDPVStatus() == "DPVNotConfirmed" || result.getDPVStatus() == "DPVConfirmedMissingSec") && QasElementService.getDpvInteractive() == "true" && QasElementService.getCountrySet() == "USA")
    {
        $button.text(qasUtil.qasMobile.useFormated);
    }
    else
    {
        $button.text(qasUtil.qasMobile.useSuggested);
    }

    $button.addClass("btn-primary");
    $button.click(events.handleClickInteractionButton);
    
    var interactionbox = document.createElement("div");
    interactionbox.setAttribute("id", "interaction_details");
    interactionbox.className = "proweb_details_left";
    interactionbox.appendChild(standardizesmessage);
    $(interactionbox).append($button);
    interactionbox.appendChild(lone);
    interactionbox.appendChild(lapt);
    interactionbox.appendChild(spacing);
    interactionbox.appendChild(llineone);
    interactionbox.appendChild(llinetwo);
    interactionbox.appendChild(llinethree);
    interactionbox.appendChild(llinecity);
    interactionbox.appendChild(llinestate);
    interactionbox.appendChild(llinezip);


    $qasWarning.append(interactionbox);

    window["interface"].selectDisplay("qasWarning");*/
        var addresses = [];
        var address = {};
        address.addressText = result.lineone + ', ' + (result.linetwo != '' ? (result.linetwo + ', ') : ' , ') + result.city + ' ' + result.state + result.zip;
        addresses.push(address);
        qas.CALLBACK(addresses);
    };

    /** ************************************************************************************************
 * Displays the refine prompt widget
 **************************************************************************************************/
    window['interface'].showRefinePrompt = function(result) {
        document.getElementById('refine_wgt').innerHTML = '';

        var message = document.createElement('dt');
        if (result.getPostcode().indexOf('.') != -1) {
            message.innerHTML = com.qas.MSG_REFINE_FOUR;
        } else {
            message.innerHTML = com.qas.MSG_REFINE;
        }
        message.className = 'qas_message';

        var $qasWarning = $('#qasWarning');
        $qasWarning.empty();
        $qasWarning.append(message);

        window['interface'].showRightDetails('qasWarning');

        var input = document.createElement('input');
        input.setAttribute('type', 'input');
        input.setAttribute('id', 'refine_input');
        input.setAttribute('value', '');
        input.className = 'qas_refinebutton';
        input.onkeypress = events.handleSubmitOnEnterKey;
        $qasWarning.append(input);

        var hinput = document.createElement('input');
        hinput.setAttribute('type', 'hidden');
        hinput.setAttribute('id', 'refine_moniker');
        hinput.setAttribute('value', result.getMoniker());
        $qasWarning.append(hinput);

        var button = document.createElement('input');
        button.setAttribute('type', 'button');
        button.setAttribute('id', 'refine_btnsubmit');
        button.setAttribute('value', 'OK');
        button.className = 'qas_refinebutton';
        button.onclick = events.handleClickRefineButton;
        $qasWarning.append(button);

        var addtext = document.createElement('dt');
        addtext.innerHTML = result.getAddressText();
        $qasWarning.append(addtext);

        window['interface'].selectDisplay('qasWarning');
        document.getElementById('refine_input').focus();
    };

    /** ************************************************************************************************
 * Thsi perfoms the logic as to which widget shoudl be displayed (this depends also on whether the
 * user has chosen to run proweb as a pop-up or not).
 **************************************************************************************************/
    window['interface'].selectDisplay = function(div_name) {
    // If the user has chosen not to display pop-ups, simply display normally
        if (QasElementService.getRunAsPopup().toLowerCase() != 'true') {
            window['interface'].showSelectedDisplay(div_name);
            current_widget = div_name;
            return;
        }

        if (div_name == 'input_wgt') {
            document.body.style.overflow = 'auto';
            window['interface'].showSelectedDisplay(div_name);
            document.getElementById('wait_wgt').style.display = 'none';
        } else {
            window['interface'].showPopupDisplay(div_name);
        }
        current_widget = div_name;
    };

    /** ************************************************************************************************
 * Due to a bug in IE6, select boxes are not placed on the correct layer (they show through the
 * cover div). This removes and then replaces them where appropriate.
 **************************************************************************************************/
    window['interface'].manageSelectFields = function(display_type) {
        var selects = document.body.getElementsByTagName('select');
        for (var i = 0; i < selects.length; i++) {
            selects[i].style.display = display_type;
        }
    };

    /** ************************************************************************************************
 * Displays the waiting widget (in case the lookup takes a while)
 **************************************************************************************************/
    window['interface'].displayWaitingWidget = function() {
        var wait = document.createElement('div');
        wait.setAttribute('id', 'wait_wgt');
        wait.className = 'wait_message';
        wait.innerHTML = com.qas.WAIT_MESSAGE + ' <img src=/signupApp/qas/qas.gif>';
    };

    /** ************************************************************************************************
 * Displays the pop-up div (if specified in the HTML)
 **************************************************************************************************/
    window['interface'].showPopupDisplay = function(div_name) {
        document.getElementById('multiple_wgt').style.display = 'none';
        document.getElementById('partial_wgt').style.display = 'none';
        document.getElementById('refine_wgt').style.display = 'none';
        document.getElementById('interaction_wgt').style.display = 'none';

        document.getElementById(div_name).style.display = '';
    };

    /** ************************************************************************************************
 * Function displays the specified widget abnd hides all others
 **************************************************************************************************/
    window['interface'].showSelectedDisplay = function(div_name) {
        document.getElementById(div_name).style.display = '';
    };

    /** ************************************************************************************************
 * This clears all of the widgets of their HTML (does not just hide them).
 **************************************************************************************************/
    window['interface'].clearNonVerifiedWidgets = function() {
        document.getElementById('multiple_wgt').innerHTML = '';
        document.getElementById('partial_wgt').innerHTML = '';
        document.getElementById('refine_wgt').innerHTML = '';
        document.getElementById('interaction_wgt').innerHTML = '';
        $('#qasWarning').empty();
    };

    /** ************************************************************************************************
 * Insert Error inline
 *************************************************************************************************/
    window['interface'].inlineError = function(errorMessage) {
        $('#inlineError').text(errorMessage);
    };
    /** ************************************************************************************************
 * The error as shown when the refine range is incorrect
 **************************************************************************************************/
    window['interface'].showRefineError = function() {
        var errorMsg = (com.qas.MSG_REFINE_ERROR);
        window['interface'].inlineError(errorMsg);
        document.getElementById('refine_input').value = '';
    };

    /** ************************************************************************************************
 * The error shown when the street partial range is incorrect
 **************************************************************************************************/
    window['interface'].showStreetPartialError = function() {
        var errorMsg = (com.qas.MSG_STREETPARTIAL_ERROR);
        window['interface'].inlineError(errorMsg);
        document.getElementById('partial_input').value = '';
    };

    /** ************************************************************************************************
 * The error shown when the premises partial range is incorrect
 **************************************************************************************************/
    window['interface'].showPremPartialError = function() {
        var errorMsg = (com.qas.MSG_PREMPARTIAL_ERROR);
        window['interface'].inlineError(errorMsg);
        document.getElementById('partial_input').value = '';
    };

    /** ************************************************************************************************
 * Displays the right hand details box (choose this address/ edit this address)
 **************************************************************************************************/
    window['interface'].showRightDetails = function(widget) {
    // Remove the right hand details if they exist
        if ($('#originaladdress').length > 0) {
            $('#originaladdress').empty();
        }
        if ($('figure').length > 0) {
            $('figure').empty();
        }

        var youentered = document.createElement('dt');
        youentered.className = 'qas_message_prompt';
        youentered.innerHTML = 'You entered: ';

        var promptedit = document.createElement('a');
        promptedit.setAttribute('onclick', 'events.handleEditAddressText();');
        promptedit.className = 'edit btn btn-secondary';
        var linkText = document.createTextNode('my title text');
        promptedit.appendChild(linkText);
        promptedit.innerHTML = 'Mobile edit';
        var promptcombo = document.createElement('dt');
        promptcombo.className = 'qas_prompt_combo';
        promptcombo.innerHTML = '<span style="font-size: 12px; font-weight: normal">You entered: </span>&nbsp; &nbsp;[&nbsp;<a onclick="events.handleEditAddressText();" style="font-size: 12px; font-weight: bold; color: #008AB0;text-decoration: underline;cursor: pointer">edit</a> ]<BR>';

        var editlink = document.createElement('dt');
        editlink.className = 'qas_edit_link';
        editlink.innerHTML = 'edit';
        editlink.onclick = events.handleEditAddressText;

        var $addressAsEntered = $('<div></div>');
        $addressAsEntered.attr('id', 'originaladdress');
        $addressAsEntered.addClass('addressAsEntered qas_message_right_details');

        var $addressPar = $('<p></p>');

        if (originaladdress.getLineOne() != '') {
            $addressPar.append(originaladdress.getLineOne() + '<br />');
        }
        if (originaladdress.getLineTwo() != '') {
            $addressPar.append(originaladdress.getLineTwo() + '<br />');
        }
        if (originaladdress.getLineThree() != '') {
            $addressPar.append(originaladdress.getLineThree() + '<br />');
        }
        if (originaladdress.getCity() != '') {
            $addressPar.append(originaladdress.getCity() + ', ');
        }
        if (originaladdress.getState() != '') {
            $addressPar.append(originaladdress.getState() + ' ');
        }
        if (originaladdress.getZip() != '') {
            $addressPar.append(originaladdress.getZip());
        }

        $addressAsEntered.append($addressPar);

        var $figureDiv = $('<div></div>');
        var $figure = $('<figure></figure>');

        var $choosebutton = $('<button></button>');
        $choosebutton.attr('id', 'choose_btnsubmit');
        $choosebutton.text('Use Entered Address');
        $choosebutton.addClass('btn-primary');
        $choosebutton.addClass('btn');
        $choosebutton.click(events.handleChooseAddressText);

        var notetext = document.createElement('figcaption');
        notetext.setAttribute('id', 'notetext');
        notetext.innerHTML = 'Undeliverable';

        $figure.append($choosebutton);
        $figure.append(promptedit);
        $figure.append(notetext);
        $figureDiv.append($figure);

        $('#' + widget).append($addressAsEntered);
        $('#' + widget).append($figureDiv);
    };

    /** ************************************************************************************************
 * The display when no match can be found (if the user has chosen to not ignore failed matches)
 **************************************************************************************************/
    window['interface'].showNoResults = function() {
    /* var $qasWarning = $("#qasWarning");
    document.getElementById("refine_wgt").innerHTML = "";
    $qasWarning.empty();
    var header = document.createElement("H2");
    header.innerHTML = com.qas.MSG_HEADER;
    $qasWarning.append(header);

    var msg = document.createElement("div");
    msg.setAttribute("id", "none_message");
    msg.innerHTML = com.qas.MSG_NONE;
    $qasWarning.append(msg);

    window["interface"].showRightDetails("qasWarning");
    window["interface"].selectDisplay("verAddress");*/
    
        qas.CALLBACK('InvalidAddress');
    
    // alert("Invalid Address");
    };

    /** ************************************************************************************************
 * Commands to run on page creation
 **************************************************************************************************/

    // Check to see which button should handle the prompt event
    business.selectInputButton();
})();




//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/util/proweb.js
// module id = 175
// module chunks = 0